/* istanbul ignore file */
import SingleOpportunityBreadcrumbs from 'domain/sales/opportunity/shared/SingleOpportunityBreadcrumbs';
import { ActivitiesAndNotesBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useOpportunityId } from 'domain/shared/opportunity';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';

const OpportunityTimelineBreadcrumbs = () => {
  const id = useOpportunityId();
  const { getTimelineUrl } = useOpportunityUrl();

  return (
    <SingleOpportunityBreadcrumbs>
      <ActivitiesAndNotesBreadcrumbItem link={getTimelineUrl(id)} />
    </SingleOpportunityBreadcrumbs>
  );
};

export default OpportunityTimelineBreadcrumbs;
